import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalStateService } from '../global/global-state.service';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  private service_type = "vendors"
    public baseURL = '';

    constructor(private _globalStateService: GlobalStateService, private _http: HttpClient) {
      this.baseURL = this._globalStateService.GetBaseEndpoint('base');
    }

    GetData(page_number: string, search: string = '',filters:Record<string,any>={}): Observable<any> {

      let params = new URLSearchParams(filters).toString();
      const url = `${this.baseURL}/${this.service_type}?page=${page_number}&search=${search}&${params}`; // Replace with your API endpoint
      return this._http.get<any>(url);
    }

    GetDataById(id: any): Observable<any> {
      const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
      return this._http.get<any>(url);
    }

    GetDataBySlug(slug: string): Observable<any> {
      const url = `${this.baseURL}/${this.service_type}/slug/${slug}`; // Replace with your API endpoint
      return this._http.get<any>(url);
    }

    DeleteDataById(id: any): Observable<any> {
      const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
      return this._http.delete<any>(url);
    }

    AddData(data: any): Observable<any> {
      const url = `${this.baseURL}/${this.service_type}`; // Replace with your API endpoint
      return this._http.post<any>(url, data);
    }

    AddToStock(id: any): Observable<any> {
      const url = `${this.baseURL}/${this.service_type}/add-to-stock/${id}`; // Replace with your API endpoint
      return this._http.post<any>(url, {});
    }

    UpdateData(id: string, data: any): Observable<any> {
      const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
      return this._http.patch<any>(url, data);
    }

    UpdateItems(id: string, data: any): Observable<any> {
      const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
      return this._http.put<any>(url, data);
    }
}
